import React, { PureComponent } from 'react';
import { Input } from 'reactstrap';
import PropTypes from 'prop-types';
import Checkbox from '../field/checkbox';
import { without } from 'underscore';

const checkboxes = [
  {
    label: 'All',
    value: ''
  },
  'Long',
  'Short'
];

function RenderCheckbox(props) {
  const { input, meta, ...additionalProps } = props;
  const checked =
    (input.value && input.value.length === 0 && props.value === '') ||
    (input.value.indexOf && input.value.indexOf(props.value) !== -1);

  console.log(input.name || props.name, input.value, props.value);
  return (
    <Checkbox
      {...additionalProps}
      type="checkbox"
      checked={checked}
      onChange={e => {
        const { checked } = e.target;

        var newValue = [].concat(input.value);

        if (checked && props.value === '') {
          newValue = [];
        } else if (checked && newValue.indexOf(props.value) === -1) {
          newValue.push(props.value);
        } else {
          newValue = without(newValue, props.value);
        }

        if (newValue.length > 1 && newValue.indexOf('') !== -1) {
          newValue = without(newValue, '');
        }

        return input.onChange(newValue);
      }}
    />
  );
}

function RenderRadio(props) {
  const { input, meta, ...additionalProps } = props;
  const checked =
    input.value === props.value || (input.value === undefined && props.value === '');

  return (
    <Checkbox
      {...additionalProps}
      type="radio"
      checked={checked}
      onChange={e => {
        const { checked, value } = e.target;

        var newValue = checked ? value : '';

        return input.onChange(newValue);
      }}
    />
  );
}

function RenderOption(props) {
  const { label, input, meta, ...additionalProps } = props;

  return <option {...additionalProps}>{label}</option>;
}

class RentalTermFilter extends PureComponent {
  static contextTypes = {
    theme: PropTypes.object
  };

  render() {
    const BS = this.context.theme;
    const { className, renderType, ...props } = this.props;

    switch (renderType) {
      case 'checkbox':
      default:
        return (
          <div className={`${BS.justifyContentSpaceBetween} ${BS.dFlex} ${BS.flexWrap}`}>
            {checkboxes.map(function (checkbox, i) {
              return (
                <RenderCheckbox
                  {...props}
                  key={i}
                  value={checkbox.value !== undefined ? checkbox.value : checkbox}
                  label={checkbox.label || checkbox}
                />
              );
            })}
          </div>
        );
      case 'radio':
        return (
          <div className={`${BS.justifyContentSpaceBetween} ${BS.dFlex} ${BS.flexWrap}`}>
            {checkboxes.map(function (checkbox, i) {
              return (
                <RenderRadio
                  {...props}
                  key={i}
                  value={checkbox.value !== undefined ? checkbox.value : checkbox}
                  label={checkbox.label || checkbox}
                />
              );
            })}
          </div>
        );
      case 'select':
        return (
          <Input type="select" name={props.input.name} onChange={props.input.onChange}>
            {checkboxes.map(function (checkbox, i) {
              return (
                <RenderOption
                  {...props}
                  key={i}
                  value={checkbox.value !== undefined ? checkbox.value : checkbox}
                  label={checkbox.label || checkbox}
                />
              );
            })}
          </Input>
        );
    }
  }
}

RentalTermFilter.defaultProps = {
  type: 'input',
  renderType: 'checkbox'
};

export default RentalTermFilter;



// WEBPACK FOOTER //
// ./src/components/form/filter/rental-term-filter.js